import classNames from 'classnames';
import { SearchResultItemProps, searchedTextInBold } from 'components/shared/compact-selector/utils';
import type { Custodian } from 'models/custodian';
import { FC, useCallback, useMemo } from 'react';
import ScrollIntoViewIfNeeded from 'react-scroll-into-view-if-needed';
import { htmlDecode } from 'utils/html-decode';

const NO_ERRORS: readonly [] = [];

function getNoErrors() {
  return NO_ERRORS;
}

export const CustodianSearchResultItem: FC<SearchResultItemProps<Custodian>> = ({
  item,
  onSelected,
  isSelected,
  searchedText,
  getError = getNoErrors,
}) => {
  const errors = useMemo(() => getError(item), [item, getError]);
  const hasErrors = errors.length > 0;
  const errorMessage = hasErrors ? errors?.join(', ') : undefined;
  const onClick = useCallback(() => onSelected(item), [onSelected, item]);
  const { id, label, eliotCode } = item;
  const decodedLabel = useMemo(() => htmlDecode(label), [label]);

  return (
    <ScrollIntoViewIfNeeded
      active={isSelected}
      elementType="tr"
      data-e2e="custodian-search-item"
      className={classNames({ 'bg-lvl3': isSelected, 'text-warning': hasErrors })}
      onClick={!hasErrors ? onClick : undefined}
      title={errorMessage}
    >
      <td className="text-truncate" data-e2e="custodian-label">
        {searchedTextInBold(decodedLabel, searchedText)}
      </td>
      <td data-e2e="custodian-id">{searchedTextInBold(id, searchedText)}</td>
      <td data-e2e="custodian-eliot-code">{eliotCode ? searchedTextInBold(eliotCode, searchedText) : ''}</td>
    </ScrollIntoViewIfNeeded>
  );
};

CustodianSearchResultItem.displayName = 'CustodianSearchResultItem';
